import {IconProps} from "../icons";


export const UploadIcon = ({width = 20, height = 20, color = "#6F3BB1"}: IconProps) => {
    return (
        <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M10 0C15.5 0 20 4.5 20 10C20 15.5 15.5 20 10 20C4.5 20 0 15.5 0 10C0 4.5 4.5 0 10 0ZM14 15V13H6V15H14ZM14 8L10 4L6 8H8.5V12H11.5V8H14Z"
                fill="currentColor"/>
        </svg>
    );
}